import "react-app-polyfill/ie11";
// import 'react-app-polyfill/stable';
import "core-js/stable";
import "regenerator-runtime/runtime";
import React from "react";
// import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import { persistor, store } from "./store";
import { PersistGate } from "redux-persist/es/integration/react";
import { Provider } from "react-redux";
import "@kenshooui/react-multi-select/dist/style.css";
import "react-select/dist/react-select.css";
import "react-virtualized/styles.css";
import "react-virtualized-select/styles.css";
import { createRoot } from "react-dom/client";
const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  //   <React.StrictMode>
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<App></App>} />
        </Routes>
      </BrowserRouter>
    </PersistGate>
  </Provider>
  //* </React.StrictMode>
);


